export const defaultPaymentTypeOptions = [
  {value: 'p2w_us', label: 'Point2Web LLC – US Bank Transfer', currency: 'USD'},
  {value: 'crypto', label: 'Crypto – Cryptocurrency Transfer', currency: 'USD'},
  {value: 'wise', label: 'Wise – International Transfer', currency: 'USD'},
  {value: 'p2w_europe_wise_usd', label: 'Point2Web Europe OÜ (Wise USD)', currency: 'USD'},
  {value: 'p2w_europe_revolut_usd', label: 'Point2Web Europe OÜ (Revolut USD)', currency: 'USD'},
  {value: 'airwallex', label: 'Airwallex', currency: 'USD'},
  {value: 'airwallex_dbs_sgp', label: 'Airwallex SWIFT – DBS Bank Singapore (USD)', currency: 'USD'},
  {value: 'pingpong', label: 'PingPong – US Bank Transfer (USD)', currency: 'USD'},
  // {value: 'p2w_europe_revolut_eur', label: 'Point2Web Europe OÜ (Revolut EUR)', currency: 'EUR'},
  // {value: 'p2w_europe_revolut_gbp', label: 'Point2Web Europe OÜ (Revolut GBP)', currency: 'GBP'},
]

export function getPaymentTypeOptions(company) {
  if (!company) {
    return cloneSafe(defaultPaymentTypeOptions)
  }

  return defaultPaymentTypeOptions.filter(option => {
    if (company === 'p2w_europe') {
      return [
        'p2w_europe_wise_usd',
        'p2w_europe_revolut_usd',
        'p2w_europe_revolut_eur',
        'p2w_europe_revolut_gbp',
      ].includes(option.value)
    }

    if (company === 'p2w_us') {
      return ['p2w_us', 'crypto', 'wise', 'airwallex', 'airwallex_dbs_sgp', 'pingpong'].includes(option.value)
    }

    return true
  })
}
